import React, { useEffect } from 'react';
import NoticeStore from '@/stores/notice';
import DetailIcon from '@/common/detail-icon';
import classNames from 'classnames';

let TimeOut: string | number | NodeJS.Timeout | null | undefined;
/**
 * 用于提示用户交互
 * 默认waring
 * 成功需要success字符串判断依据
 * @returns
 */
export default function Notice({ style = {} }: { style?: object }) {
  const noticeStore = NoticeStore((state) => state);
  const noticeInfo = noticeStore.message;

  useEffect(() => {
    if (noticeInfo) {
      // 清理提示
      if (TimeOut) {
        clearTimeout(TimeOut);
        TimeOut = null;
      }
      TimeOut = setTimeout(() => {
        noticeStore.modify('');
      }, 4 * 1000);
    }
  }, [noticeInfo]);

  return (
    <div
      className={classNames({
        'notice-layout': true,
        success: noticeInfo.split('_')[1] === 'success',
      })}
      style={{
        ...style,
        display: !!noticeInfo ? 'block' : 'none',
      }}
    >
      {noticeInfo.split('_')[1] === 'success' ? (
        <DetailIcon className="detail-symbol" symbol={'icon-success'} />
      ) : (
        <DetailIcon className="detail-symbol" symbol={'icon-info'} />
      )}
      <span className="detail-notice-info">{noticeInfo.split('_')[0]}</span>
    </div>
  );
}
